import {
  deleteTeamUser as deleteTeamUserApi,
  validateEmail as validateEmailApi,
  sendInvitation as sendInvitationApi
} from '@/api/team'
import driver from './driver'
import operator from './operator'
import user from './user'
const state = {
  namespaced: true,
  state: {},
  actions: {
    deleteDriverUser(context, userInfo) {
      let params = {
        email: userInfo.email,
        status: userInfo.status.toUpperCase()
      }
      return deleteTeamUserApi(params)
    },
    // 邮箱验证
    validateEmail(context, email) {
      return validateEmailApi({ email }).then(
        () => {
          return Promise.resolve('success')
        },
        error => {
          try {
            let data = error.error.response.request
            let text = ''
            switch(data.responseText) {
              case "the user is already in other's team":
                text = 'You cannot add active members of another fleet.'
                break
              case 'the user is already in your team':
                text = 'This user is already in your fleet.'
                break
              case 'the user has already invited by you':
                text = 'You already sent an invitation to this user.'
            }
            return text ? Promise.reject(text) : Promise.resolve('success')
          } catch {
            return Promise.resolve('success')
          }
        }
      )
    },
    // 发送邀请
    sendInvite(context, data) {
      let params = {
        query: { role: data.identity.toUpperCase(), confirmation: data.confirmation },
        data: data.list
      }
      return sendInvitationApi(params).then(
        result => {
          try {
            let list = result.res.data || []
            let info = list.find(item => item.failed !== 'false')
            if (info) {
              return Promise.resolve({ list, status: false })
            }
            return Promise.resolve({ list, status: true })
          } catch(error) {
            return Promise.reject(error)
          }
        },
        error => {
          return Promise.reject(error)
        }
      )
    }
  },
  modules: {
    driver,
    operator,
    user
  }
}

export default state